export const mentionsStyles = {
  control: {
    backgroundColor: "transparent",
    fontFamily: "Manrope, ui-sans-serif, system-ui",
    fontSize: 14,
    lineHeight: "20px",
    minHeight: 70,
    // IMPORTANT: don't set fixed height here
  },
  highlighter: {
    border: "none",
    boxSizing: "border-box",
    lineHeight: "20px",
    maxHeight: 107, // optional – must match input if you add it
    minHeight: 70,
    overflow: "auto", // match input
    padding: 0,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
  },
  input: {
    border: "none",
    boxSizing: "border-box",
    color: "white",
    lineHeight: "20px",
    maxHeight: 107, // optional – must match highlighter if you add it
    minHeight: 70,
    outline: "none",
    overflow: "auto", // match highlighter
    padding: 0,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
  },
  suggestions: {
    list: {
      backgroundColor: "white",
      border: "1px solid #eaecf0",
      borderRadius: 8,
      maxHeight: 320,
      maxWidth: 185,
      minWidth: 185,
      overflowY: "auto",
      padding: "4px",
    },
  },
};
